import React from 'react';
import UploadButton from './UploadButton';
import useI18n from '../../hooks/useI18n';

interface SuccessMessageProps {
  smartLinksCreated: number;
  onGoToLinks: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  smartLinksCreated,
  onGoToLinks,
}) => {
  const { t } = useI18n();

  return (
    <div className="flex flex-col items-center justify-center h-64 lg:h-72 text-center">
      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="w-8 h-8 text-blue-600"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <p className="text-gray-700 font-medium">
        {t('bulkUpload.successMessage', {
          count: smartLinksCreated,
          smartLinks:
            smartLinksCreated > 1 ? t('common.links') : t('common.link'),
        })}
      </p>
      <UploadButton label={t('bulkUpload.goToMyLinks')} onClick={onGoToLinks} />
    </div>
  );
};

export default SuccessMessage;
